import { dataCellphone } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCellphone = /*#__PURE__*/createIcon(dataCellphone)
export default IconCellphone
